import { Component, OnInit } from '@angular/core';
import { Constants } from '../utils/constants';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  facebookUrl: String = Constants.facebookPageUrl;
  linkedinUrl: String = Constants.linkedInPageUrl;
  instagramUrl: String = Constants.instagramPageUrl;
  currentYear: String;

  constructor() {
    this.currentYear = new Date().getFullYear().toString();
  }

  ngOnInit(): void {
  }
}
